import React from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4em 0;

  div {
    max-width: 768px;
  }
  .main-list {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }
  .sub-list {
    padding-left: 20px;
  }

  @media (max-width: 768px) {
    div {
      max-width: 100%;
      padding: 20px 20px;
    }
    .main-list {
      flex-direction: column;
    }
    .sub-list {
      padding-left: 0;
    }
  }
`

const Privacy = () => {
  return (
    <Container>
      <div>
        <h1
          style={{
            textAlign: "center",
            fontWeight: "Bold",
            fontSize: "1.6rem",
          }}
        >
          {
            "伊方町デジタル商品券アプリ プライバシーポリシー（個人情報の取り扱いについて）"
          }
        </h1>
        <p style={{ padding: "2em 0" }}>
          {
            "伊方町は、伊方町デジタル商品券アプリ（以下、「本アプリ」といいます。）の提供にあたり、利用者様の個人情報の取り扱いについて以下のとおりお知らせします。"
          }
        </p>
        <p className={"main-list"}>
          <ol style={{ paddingLeft: "1rem" }}>
            <li style={{ fontWeight: "Bold", marginBottom: 8 }}>
              {"取得する個人情報"}
            </li>
            <p>
              {
                "伊方町は、本アプリを通じて利用者様から以下の個人情報を取得します。"
              }
            </p>
            <ol style={{ paddingLeft: "1.2rem" }}>
              <li>
                {
                  "本アプリの利用者情報編集機能により保存される情報（氏名、性別、生年月日、住所、集落名）"
                }
              </li>
              <li style={{ marginBottom: 8 }}>
                {"ログイン時の顔撮影による顔画像"}
              </li>
            </ol>
            <li style={{ fontWeight: "Bold", marginBottom: 8 }}>
              {"個人情報の収集と利用"}
            </li>
            <p>
              {
                "本アプリの利用者情報編集機能により編集された情報は、集落のグループホーム化DX 基盤サービスの利用者情報として保存されます。この情報は本アプリの操作で削除することはできません。削除をする場合は直接役場へお申し出ください。"
              }
            </p>
            <p>
              {
                "本アプリではログイン時の撮影アクションにより利用者様の顔画像を取得し、ログインユーザーの検索に使用します。他の目的で使用することはありません。"
              }
            </p>
            <p>
              {"本アプリで取得した顔画像は、ログイン後直ちに破棄されます。"}
            </p>
            <p>
              {
                "伊方町は、個人情報の漏えい、滅失またはき損の防止その他の個人情報の安全管理のため、適切な措置を講じます。具体的には以下の対策を実施しています。"
              }
            </p>
            <ul>
              <li>{"個人情報へのアクセス制限、アクセス者の識別と認証"}</li>
              <li>{"外部からの不正アクセスの防止"}</li>
              <li>{"個人情報を取り扱う従業者及び委託先への監督と教育"}</li>
            </ul>
            <li style={{ fontWeight: "Bold", marginBottom: 8, marginTop: 16 }}>
              {"個人情報の取扱業務の委託"}
            </li>
            <p>
              {
                "伊方町は、本サービスに関する業務の一部を外部に委託し、委託先に対して利用者様の個人情報を預けることがあります。この場合、個人情報を適切に取り扱っていると認められる委託先を選定し、委託先が個人情報の安全管理のために必要かつ適切な措置を実施するよう監督を行います。"
              }
            </p>

            <li style={{ fontWeight: "Bold", marginBottom: 8 }}>
              {"第三者への提供"}
            </li>
            <p>
              {
                "伊方町は、法令で定められている場合を除いて、利用目的以外の目的のために利用者様の個人情報を第三者（外国の第三者を含みます。）に提供することはありません。"
              }
            </p>

            <li style={{ fontWeight: "Bold", marginBottom: 8 }}>
              {"個人情報提供の任意性"}
            </li>
            <p>
              {
                "利用者様が伊方町に対して個人情報を提供することは任意です。ただし、必要な個人情報を提供いただけない場合には、伊方町が本サービスを提供できない場合があります。"
              }
            </p>

            <li style={{ fontWeight: "Bold", marginBottom: 8 }}>
              {"個人情報の開示等の請求"}
            </li>
            <p>
              {
                "利用者様が伊方町に個人情報を提供した場合、利用者様は、個人情報の内容について、開示、訂正および利用停止（総称して以下、「開示等」といいます。）を請求することができます。伊方町に対し、開示等の請求をされる場合は、以下のお問合せ窓口までご連絡ください。"
              }
            </p>
          </ol>
        </p>

        <h2 style={{ fontWeight: "Bold", fontSize: "1.2rem" }}>
          {"お問合せ窓口"}
        </h2>
        <p>
          {"担当課：総合政策課"}
          <br />
          {"Tel：0894-38-2659"}
          <br />
          {
            "受付時間：午前8時30分から午後5時15分まで（土曜、日曜、祝日、年末年始は除く）"
          }
        </p>
      </div>
    </Container>
  )
}
export default Privacy
